/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileUnknownLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FileUnknownLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M46.994 33.537C46.85 28.13 43.904 25.5 38 25.5s-8.85 2.63-8.994 8.037C24.776 34.617 22 36.437 22 38.5c0 1.678 1.837 3.195 4.797 4.284l-2.154 4.577 2.714 1.278 2.356-5.006c2.014.459 4.32.755 6.787.841V50.5h3v-6.026c2.434-.085 4.71-.374 6.704-.822l2.425 5.457 2.742-1.218-2.256-5.075C52.127 41.725 54 40.194 54 38.5c0-2.063-2.777-3.883-7.006-4.963Zm-13.71-3.756c-.681.64-1.284 1.823-1.284 4.18v.666a15.535 15.535 0 0 0 12 0v-.666c0-2.357-.603-3.54-1.284-4.18C42 29.107 40.631 28.5 38 28.5c-2.63 0-3.999.607-4.716 1.281Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M32.004 34.628a15.534 15.534 0 0 0 11.992 0c.003.109.004.22.004.334v.665a15.535 15.535 0 0 1-12 0v-.666c0-.113.001-.224.004-.333Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M38 25.5c5.904 0 8.85 2.63 8.994 8.037 4.23 1.08 7.006 2.9 7.006 4.963 0 .168-.019.335-.055.5-.408-1.855-3.067-3.471-6.95-4.463C46.85 29.13 43.903 26.5 38 26.5c-5.904 0-8.85 2.63-8.994 8.037-3.884.992-6.543 2.608-6.951 4.463a2.32 2.32 0 0 1-.055-.5c0-2.063 2.777-3.883 7.006-4.963C29.15 28.13 32.096 25.5 38 25.5ZM26.398 43.632l-1.755 3.73.385.18 1.769-3.758c-.135-.05-.268-.1-.4-.152ZM51 48.056l.37-.165-1.874-4.218c-.125.048-.252.096-.38.143L51 48.056Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileUnknownLarge
};
